<template>
  <div class="form-item-textfield">
    <label :for="element.metadata?.key">{{ element.metadata?.title }}</label>
    <input :id="element.metadata?.key" :required="element.metadata?.required ?? false" :name="element.metadata?.key" type="text" :value="prefill">
  </div>
</template>
<script setup lang="ts">
import { type WebformElementTextBaseFragment, type WebformSubmissionValidationErrorFragment } from '#graphql-operations'

const props = defineProps<{
  element: WebformElementTextBaseFragment
  formErrors: WebformSubmissionValidationErrorFragment[]
  prefilledInputs: InputPrefill[]
}>()

const { prefill } = useInputPrefill(props.prefilledInputs, props.element)

</script>

<style lang="scss">
@use "~/assets/sass/tools";

.form-item-textfield {
  @include tools.form-group-text;
}
</style>
